import type { MutationHookOptions } from "@apollo/client";
import { gql, useMutation } from "@apollo/client";

import type { AuthUserTwoFactorAuthenticationResendError } from "@shared/types/graphqlGenerated";

const ResendTwoFactorAuthPasscodeEmail_UnauthenticatedShared_Mutation = gql`
  mutation ResendTwoFactorAuthPasscodeEmail_UnauthenticatedShared_Mutation(
    $input: AuthUserTwoFactorAuthenticationResendInput!
  ) {
    auth {
      userResendTwoFactorAuthentication(input: $input) {
        sent
        errors {
          message
        }
      }
    }
  }
`;

interface ResendTwoFactorAuthPasscodeEmailData {
  auth: {
    userResendTwoFactorAuthentication: {
      sent: boolean;
      errors: AuthUserTwoFactorAuthenticationResendError;
    };
  };
}

interface Variables {
  input: {
    captchaToken: string;
    token: string;
  };
}

const useResendTwoFactorAuthPasscodeEmailMutation = (
  options?: MutationHookOptions<ResendTwoFactorAuthPasscodeEmailData, Variables>
) =>
  useMutation<ResendTwoFactorAuthPasscodeEmailData, Variables>(
    ResendTwoFactorAuthPasscodeEmail_UnauthenticatedShared_Mutation,
    options
  );

export type { ResendTwoFactorAuthPasscodeEmailData };
export {
  useResendTwoFactorAuthPasscodeEmailMutation,
  ResendTwoFactorAuthPasscodeEmail_UnauthenticatedShared_Mutation,
};
